import React, { useEffect, useMemo, useState } from 'react';
import { useForm } from '@inertiajs/inertia-react';
import Input from '@/Components/Input';
import Label from '@/Components/Label';
import Button from '@/Components/Button';
import Error from '@/Components/Error';
import { DateTime } from 'luxon';


export function ScheduleCreation({ presets, branchOffice }) {

    const { data, setData, processing, errors, post, transform } = useForm({
        'startDate': presets.startDate,
        'startTime': presets.startTime.substr(0, 5),
        'hoursToCreate': presets.hoursToCreate,
        'quota': presets.quota,
        'birthday_limit': presets.birthday_limit
        //'adultsPrice': presets.adultsPrice,
        //'adultsQuota': presets.adultsQuota,
        //'childrenPrice': presets.childrenPrice,
        //'childrenQuota': presets.childrenQuota,
    });

    const onHandleChange = (e) => {
        setData(e.target.name, e.target.value);
    };

    const submit = e => {
        e.preventDefault();
        post(route('schedule.store', {
            office: branchOffice.slug
        }), {
            preserveState: true
        });
    };

    const submitMonth = e => {
        e.preventDefault()
        post(route('schedule.store.month', {
            office: branchOffice.slug
        }), {
            preserveState: true
        });
    }

    const max = useMemo(() => Math.abs(parseInt(DateTime.fromFormat(data.startTime, 'HH:mm').toFormat('H')) - 24), [data.startTime])

    useEffect(() => {
        if (data.hoursToCreate > max) {
            setData('hoursToCreate', max)
        }
    }, [data.startTime])

    // console.log({ startTime: parseInt(DateTime.fromFormat(data.startTime, 'HH:mm').toFormat('H')), endTime: parseInt(DateTime.fromFormat('00:00', 'HH:mm').toFormat('H')), hoursToCreate: data.hoursToCreate })
    // console.log({ result:  });

    return (
        <form className='bg-white shadow-sm sm:rounded-lg border-b border-gray-200 p-3 lg:mt-4' onSubmit={submit}>

            <h2 className="mb-4 text-gray-900 text-lg font-bold">Creación de cupos</h2>
            <div className="flex flex-col gap-3">
                <div>
                    <Label forInput="startTime" value="Hora de inicio" />
                    <Input
                        type="time"
                        name="startTime"
                        value={data.startTime}
                        className="mt-1 block w-full"
                        isFocused={true}
                        required={true}
                        handleChange={onHandleChange} />
                    <Error bind={errors.startTime} />
                </div>
                <div>
                    <Label forInput="hoursToCreate" value="Horas a crear" />
                    <Input
                        type="number"
                        min={1}
                        max={max}
                        name="hoursToCreate"
                        value={data.hoursToCreate}
                        className="mt-1 block w-full"
                        isFocused={true}
                        required={true}
                        handleChange={onHandleChange} />
                    <Error bind={errors.hoursToCreate} />
                </div>

                {/* <div>
                    <Label forInput="adultsPrice" value="Precio tickets" />
                    <Input
                        type="number"
                        min="0"
                        name="adultsPrice"
                        value={data.adultsPrice}
                        className="mt-1 block w-full"
                        isFocused={true}
                        required={true}
                        handleChange={onHandleChange} />
                    <Error bind={errors.adultsPrice} />
                </div> */}

                <div>
                    <Label forInput="quota" value="Aforo por hora" />
                    <Input
                        type="number"
                        min="0"
                        name="quota"
                        value={data.quota}
                        className="mt-1 block w-full"
                        isFocused={true}
                        required={true}
                        handleChange={onHandleChange} />
                    <Error bind={errors.quota} />
                </div>

                <div>
                    <Label forInput="birthday_limit" value="Aforo por hora de cumpleaños" />
                    <Input
                        type="number"
                        min="0"
                        name="birthday_limit"
                        value={data.birthday_limit}
                        className="mt-1 block w-full"
                        isFocused={true}
                        required={true}
                        handleChange={onHandleChange} />
                    <Error bind={errors.birthday_limit} />
                </div>

            </div>

            <div className="">
                <button type="button" className="rounded bg-primary text-white py-2 px-5 text-xs uppercase mr-5"
                    onClick={(e)=>{
                        submitMonth(e)
                    }}
                >Llenar mes</button>
                <Button className='mt-4 ml-auto' processing={processing}>
                    Crear
                </Button>
            </div>
        </form>
    );
}
